import { Box, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

interface IPageHeaderProps {
  title: any;
  description?: string;
  actions?: ReactElement;
  leftBackButton?: any;
  customDescription?: any;
  customStyleTitleSection?: any;
  customStyleActionSection?: any;
  customIcon?: any;
  noPadding?: boolean;
}

const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  description,
  actions = null,
  leftBackButton = null,
  customDescription = null,
  customStyleTitleSection = null,
  customStyleActionSection = null,
  customIcon = null,
  noPadding = false,
}) => (
  <Box
    className="page-header mt-6 mb-4"
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 3,
      width: '100%',
      boxSizing: 'border-box',
      px: noPadding ? 0 : { xs: 2, sm: 3, md: '35px' },
    }}
  >
    {customIcon && <Box sx={{ flexShrink: 0 }}>{customIcon}</Box>}

    <Stack
      className="title-section"
      sx={{
        flex: '1 1 auto',
        minWidth: 0,
        ...(customStyleTitleSection || {}),
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ minWidth: 0 }}
      >
        {leftBackButton}

        <Typography
          className="f26 fw-7 word-break"
          sx={{
            fontSize: { xs: 20, sm: 24, md: 26 },
            fontWeight: 700,
            lineHeight: '30px',
            overflowWrap: 'anywhere',
          }}
        >
          {title}
        </Typography>
      </Stack>

      {description && (
        <Typography
          className="f16 word-break"
          sx={{
            fontSize: { xs: 14, sm: 16 },
            lineHeight: '25px',
            mt: 0.5,
          }}
        >
          {description}
        </Typography>
      )}

      {customDescription}
    </Stack>

    {actions && (
      <Box
        className="action-section"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          flex: '0 0 auto',
          minWidth: 0,
          ...(customStyleActionSection || {}),
        }}
      >
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
